function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
//

import * as React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import { StyleSheet, css, color as colorAlt } from "../../styles/theme";
import { SvgStar, SvgStarFilled, SvgStarHalfFilled, SvgStarHalfFade } from "../../svg";
import { fade, darken } from "../../utils/colorUtils";
import generateUUID from "../../utils/generateUUID";
var DEFAULT_OPACITY = 0.4;
var ICON_SIZE = 14;
var STAR_SPACING = 2;
var styles = StyleSheet.create({
  StarRating: {
    display: 'inline-block',
    position: 'relative'
  },
  nonEditable: {
    cursor: 'inherit'
  },
  star: {
    cursor: 'inherit'
  },
  starInteractive: {
    cursor: 'pointer'
  },
  starNoninteractive: {
    marginBottom: '0.5rem'
  }
});
function defaultRenderStarFn(_ref) {
  var propColor = _ref.color,
    enableColorOpacity = _ref.enableColorOpacity,
    hoverColor = _ref.hoverColor,
    isEmpty = _ref.isEmpty,
    isFull = _ref.isFull,
    stroke = _ref.stroke,
    isHalf = _ref.isHalf,
    isInteractive = _ref.isInteractive,
    starSpacing = _ref.starSpacing,
    dir = _ref.dir;
  var hoverColorProp = isInteractive ? {
    hoverColor: hoverColor
  } : {};
  var Tag = isFull ? SvgStarFilled : SvgStar;
  if (enableColorOpacity) {
    var color = isEmpty ? 'var(--cds-color-white-0, #ffffff)' : propColor;
    if (isHalf) {
      Tag = SvgStarHalfFade;
    }
    return /*#__PURE__*/React.createElement(Tag, _extends({
      style: {
        marginRight: starSpacing,
        verticalAlign: 'text-bottom'
      },
      size: ICON_SIZE,
      color: color,
      dir: dir,
      stroke: stroke,
      "aria-hidden": true
    }, hoverColorProp));
  }
  if (isHalf) {
    Tag = SvgStarHalfFilled;
  }
  return /*#__PURE__*/React.createElement(Tag, _extends({
    style: {
      marginRight: starSpacing,
      verticalAlign: 'text-bottom'
    },
    size: ICON_SIZE,
    color: propColor,
    stroke: stroke,
    "aria-hidden": true,
    dir: dir
  }, hoverColorProp));
}
var StarRating = /*#__PURE__*/function (_React$Component) {
  function StarRating(props, context) {
    var _this;
    _classCallCheck(this, StarRating);
    _this = _callSuper(this, StarRating, [props, context]);
    _defineProperty(_this, "onChange", function (rating) {
      return function (ev) {
        if (ev && ev.preventDefault) {
          ev.preventDefault();
          ev.stopPropagation();
        }
        var _this$props = _this.props,
          onChange = _this$props.onChange,
          isInteractive = _this$props.isInteractive,
          name = _this$props.name;
        if (_this.props.isInteractive) {
          _this.setState(function () {
            return {
              rating: rating
            };
          });
        }
        if (isInteractive && onChange) {
          onChange(rating, name);
        }
      };
    });
    _defineProperty(_this, "renderStars", function () {
      var _this$props2 = _this.props,
        name = _this$props2.name,
        limit = _this$props2.limit,
        _this$props2$isIntera = _this$props2.isInteractive,
        isInteractive = _this$props2$isIntera === void 0 ? false : _this$props2$isIntera,
        tabIndexAlt = _this$props2.tabIndex,
        renderStar = _this$props2.renderStar,
        isThemeDark = _this$props2.isThemeDark,
        color = _this$props2.color,
        hoverColor = _this$props2.hoverColor,
        stroke = _this$props2.stroke,
        _this$props2$enableCo = _this$props2.enableColorOpacity,
        enableColorOpacity = _this$props2$enableCo === void 0 ? false : _this$props2$enableCo,
        _this$props2$starSpac = _this$props2.starSpacing,
        starSpacing = _this$props2$starSpac === void 0 ? STAR_SPACING : _this$props2$starSpac,
        dir = _this$props2.dir,
        a11yIdentifier = _this$props2.a11yIdentifier;
      var rating = _this.state.rating;
      var tabIndex = isInteractive ? tabIndexAlt : -1;
      if (!a11yIdentifier && !_this.uuid) {
        _this.uuid = generateUUID();
      }
      return range(limit).reduce(function (total, index) {
        var curRating = index + 1;
        var id = [name, curRating, a11yIdentifier || _this.uuid].filter(function (str) {
          return !!str;
        }).join('_');
        var starInputElem = /*#__PURE__*/React.createElement("input", {
          key: id,
          id: id,
          className: "sr-only",
          type: "radio",
          name: name,
          value: curRating,
          checked: rating === curRating,
          onChange: _this.onChange(curRating)
        });
        var starElemProps = {
          onClick: _this.onChange(curRating),
          onKeyPress: _this.onChange(curRating),
          tabIndex: tabIndex
        };
        var decimalPartOfRating = rating % 1;
        var integerPartOfRating = Math.floor(rating);
        var isHalf = integerPartOfRating + 1 === curRating && decimalPartOfRating >= 0.25 && decimalPartOfRating <= 0.75;
        var isFull = curRating < rating + 0.25;
        var isEmpty = !isHalf && !isFull;
        var starSvg = renderStar({
          index: index,
          rating: rating,
          isThemeDark: isThemeDark,
          isFull: isFull,
          isHalf: isHalf,
          isEmpty: isEmpty,
          color: color,
          enableColorOpacity: enableColorOpacity,
          stroke: stroke,
          isInteractive: isInteractive,
          hoverColor: hoverColor,
          starSpacing: starSpacing,
          dir: dir
        });
        var starElem = isInteractive ? /*#__PURE__*/React.createElement("label", _extends({
          key: id
        }, css('d-inline-block', styles.starInteractive, styles.star), starElemProps, {
          htmlFor: id
        }), starInputElem, starSvg) : /*#__PURE__*/React.createElement("span", _extends({
          key: id
        }, css('d-inline-block', styles.star, styles.starNoninteractive)), starSvg);
        total.push(starElem);
        return total;
      }, []);
    });
    _this.state = {
      rating: props.rating
    };
    _this.uuid = undefined;
    return _this;
  }
  _inherits(StarRating, _React$Component);
  return _createClass(StarRating, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('rating' in nextProps && nextProps.rating !== this.state.rating) {
        this.setState(function () {
          return {
            rating: nextProps.rating
          };
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        ariaLabel = _this$props3.ariaLabel,
        isInteractive = _this$props3.isInteractive,
        htmlAttributes = _this$props3.htmlAttributes,
        style = _this$props3.style,
        rootClassName = _this$props3.rootClassName,
        dir = _this$props3.dir;
      return /*#__PURE__*/React.createElement("div", _extends({}, htmlAttributes, css(rootClassName, styles.StarRating, !isInteractive && styles.nonEditable), !isInteractive && {
        role: 'img'
      }, {
        style: style,
        dir: dir,
        "aria-label": ariaLabel
      }), this.renderStars());
    }
  }]);
}(React.Component);
_defineProperty(StarRating, "propTypes", {
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object,
  htmlAttributes: PropTypes.object,
  isThemeDark: PropTypes.bool,
  // Name for input element
  name: PropTypes.string,
  ariaLabel: PropTypes.string,
  // Actual rating
  rating: PropTypes.number.isRequired,
  tabIndex: PropTypes.number,
  starSpacing: PropTypes.number,
  // If false, the rating will be read only.
  isInteractive: PropTypes.bool,
  // If disabled, we'll use alternative icons and colors for empty and half star
  enableColorOpacity: PropTypes.bool,
  // Total number of stars available
  limit: PropTypes.number,
  onChange: PropTypes.func,
  renderStar: PropTypes.func,
  color: PropTypes.string,
  stroke: PropTypes.string,
  dir: PropTypes.oneOf(['rtl', 'ltr']),
  hoverColor: PropTypes.string,
  a11yIdentifier: PropTypes.string
});
_defineProperty(StarRating, "defaultProps", {
  rootClassName: '',
  style: {},
  htmlAttributes: {},
  name: 'StarRating',
  limit: 5,
  rating: 0,
  tabIndex: 0,
  stroke: 'var(--cds-color-yellow-800, #7c6919)',
  color: 'var(--cds-color-yellow-200, #f2d049)',
  hoverColor: darken('var(--cds-color-yellow-200, #f2d049)', 0.4),
  renderStar: defaultRenderStarFn,
  starSpacing: STAR_SPACING,
  a11yIdentifier: ''
});
export { StarRating as default };